import * as React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { GetOrganizations } from "../../../services/organization.handlers";
import { useSelector } from "react-redux";
import { jsonCheck } from "../../../constants";
import { GetStores } from "../../../services/store.handlers";

const TableRowData = [
  "ID",
  "Name",
  "Contact Info",
  "Address",
  "Attached Store's",
  "Status",
  "Action",
  "Add / Remove Store",
];

const Dashboard = () => {
  const navigate = useNavigate();
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const authToken = useSelector((state) => state.user.authToken);
  React.useEffect(() => {
    fetchData();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = () => {
    var options = {
      Authorization: "Bearer " + authToken,
    };
    GetOrganizations(options).then((response) => {
      if (response.status) {
        setData(response.data);
      }
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <DashboardLayout>
      <Stack
        spacing={2}
        direction="row"
        style={{ marginBottom: "30px", justifyContent: "end" }}
      >
        <Button
          onClick={() => navigate("/add_organization/" + data.length)}
          variant="contained"
        >
          <AddIcon /> Add New Organization
        </Button>
      </Stack>
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size={"medium"}
        >
          <TableHead>
            <TableRow>
              {TableRowData.map((item, index) => (
                <TableCell key={index}>
                  {index == -1 ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          //   indeterminate={numSelected > 0 && numSelected < rowCount}
                          //   checked={rowCount > 0 && numSelected === rowCount}
                          //   onChange={onSelectAllClick}
                          inputProps={{
                            "aria-label": "select all ID",
                          }}
                        />
                      }
                      label={item}
                    />
                  ) : (
                    item
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow
                    hover
                    //   onClick={(event) => handleClick(event, row.name)}
                    role="checkbox"
                    //   aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={index}
                    //   selected={isItemSelected}
                  >
                    <TableCell>{item.org_Id}</TableCell>
                    <TableCell>{item.org_Name}</TableCell>
                    <TableCell>
                      {item.contact_Email}
                      <br />
                      {item.contact_Number}
                    </TableCell>
                    <TableCell>
                      {item.org_Address_1 + " " + item.org_Address_2 + ", "}
                      {jsonCheck(item.city)
                        ? JSON.parse(item.city).label
                        : item.city}{" "}
                      {", "}
                      {jsonCheck(item.state)
                        ? JSON.parse(item.state).label
                        : item.state}{" "}
                      {", "}
                      {item.zip + " - "}
                      {jsonCheck(item.country)
                        ? JSON.parse(item.country).label
                        : item.country}
                    </TableCell>
                    <TableCell>
                      {item.store.map((element) => element.store_Id + ",")}
                    </TableCell>
                    <TableCell>
                      {item.isActive ? (
                        <span className={"label color-green"}>Active</span>
                      ) : (
                        <span className={"label color-red"}>Blocked</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() =>
                          navigate("/updateOrganization/" + item.id)
                        }
                        variant="contained"
                        color="primary"
                      >
                        Edit
                      </Button>
                    </TableCell>
                    <TableCell style={{ minWidth: "130px" }}>
                      <button
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/add_stores/" + item.id)}
                      >
                        Add
                      </button>
                      {" / "}
                      <button
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate("/removeStoreFromStore/" + item.id)
                        }
                      >
                        Remove
                      </button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow hover>
                <TableCell
                  colSpan={8}
                  align={"center"}
                  // id={labelId}
                  scope="row"
                  // padding="checkbox"
                >
                  No Records Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 30, 40]}
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </DashboardLayout>
  );
};

export default Dashboard;
